import { getActivePinia, PiniaPluginContext } from 'pinia'

export function piniaResetPlugin({ store }: PiniaPluginContext) {
  // Snapshot do state inicial via deep clone JSON-only.
  // Restricao: stores nao podem conter Map, Set, Date ou undefined no state — todos atuais sao JSON-safe.
  const initialState = JSON.parse(JSON.stringify(store.$state))

  // Pinia options-stores ja tem $reset nativo (presenca de $options.state).
  // Setup-stores (composition API) nao tem — sobrescrevemos com snapshot deep-clone.
  if (!store.$options?.state) {
    store.$reset = () => {
      store.$patch(($state: Record<string, unknown>) => {
        Object.assign($state, JSON.parse(JSON.stringify(initialState)))
      })
    }
  }
}

export function resetAllStores() {
  const pinia = getActivePinia() as ReturnType<typeof getActivePinia> & {
    _s: Map<string, { $reset: () => void }>
  }
  if (!pinia) return
  pinia._s.forEach((store) => {
    store.$reset()
  })
}
